import _ from 'lodash';

import { OTHER } from 'constants/prescriptionConstants';
import { Option } from 'types/select';

export type UltraFormData = {
  treatmentSpecifications?: import('types/UltraPrescription.types').UltraTreatmentSpecType;
};

export type PositionSubOption = {
  position?: string;
  value?: string;
  specification?: string;
  archExpansion?: string;
  proclination?: string;
  molarDistalization?: string[];
  options?: {
    value?: string[];
    text?: string;
    anteriorBiteRampsOptions?: string[];
  };
  ipr?: {
    value?: string;
    primaryIpr?: {
      anteriorTeeth?: string;
      rightPosteriorTeeth?: string;
      leftPosteriorTeeth?: string;
    };
  };
};

export const getStringValue = (
  obj: Record<string, unknown> | undefined,
  path: string
): string => {
  const value = _.get(obj, path);
  return typeof value === 'string' ? value : '';
};

export const isOtherOptionSelected = (selectedOptions: Option[]) => {
  return selectedOptions?.find((option) => option?.value === OTHER);
};

export const isOptionSelected = (
  selectedOptions: Option[],
  selectedValue: string
) => {
  return selectedOptions?.find((option) => option?.value === selectedValue);
};

export const convertToOptionsType = (
  options: Option[],
  savedList?: string[]
) => {
  return options.filter((option: Option) => savedList?.includes(option.value));
};

export const getSubOptionFromList = (
  position: string,
  subOptionList?: PositionSubOption[]
) => {
  return subOptionList?.find((subOption) => subOption?.position === position);
};
